import createMaintenanceService from "./createMaintenanceService";

export default createMaintenanceService(
    "/User/currentMe",
    "User/change-password"
);
